"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnEscapePressed = void 0;

var _react = require("react");

/**
 * Handle the escape key pressed.
 */
var useOnEscapePressed = function useOnEscapePressed(onEscape) {
  var keyDown = (0, _react.useCallback)(function (evt) {
    if (evt.code === "Escape") {
      onEscape();
    }
  }, [onEscape]);
  (0, _react.useEffect)(function () {
    document.addEventListener("keydown", keyDown);
    return function () {
      document.removeEventListener("keydown", keyDown);
    };
  }, [keyDown]);
};

exports.useOnEscapePressed = useOnEscapePressed;